import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class LinearRegressionR2Tooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const value = currentItem && yAccessor(currentItem);

    const displayValue = (isDefined(value) && displayFormat(value)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Map sourcePath to short display label
    const sourceLabels = {
      open: "Abe",
      high: "Máx",
      low: "Mín",
      close: "Fec",
      hl2: "HL/2",
      hlc3: "HLC/3",
      ohlc4: "OHLC/4",
      hlcc4: "HLCC/4",
    };
    const sourceLabel = sourceLabels[options.sourcePath] || "Fec";

    // Get stroke color
    const strokeColor = appearance?.stroke?.color || textFill;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-linear-regression-r2"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>Lin R2 (</ToolTipTSpanLabel>
          <tspan fill={strokeColor}>{sourceLabel}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={strokeColor}>{options.period}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={strokeColor}>{displayValue}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

LinearRegressionR2Tooltip.propTypes = {
  className: PropTypes.string,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  displayValuesFor: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  appearance: PropTypes.shape({
    stroke: PropTypes.shape({
      color: PropTypes.string,
    }),
  }),
  options: PropTypes.shape({
    period: PropTypes.number.isRequired,
    sourcePath: PropTypes.string.isRequired,
  }).isRequired,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
};

LinearRegressionR2Tooltip.defaultProps = {
  className: "react-stockcharts-tooltip react-stockcharts-linr2-tooltip",
  displayFormat: format(".3f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
  labelFill: "#4682B4",
  textFill: "#000000",
};

export default LinearRegressionR2Tooltip;
